import { Box, makeStyles, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { ITransactionHistory } from '../../models/Inquiry/TransactionHistory/ITransactionHistory';
import { IDebtor } from '../../models/Roll/IDebtor';
import { useGlobalState } from '../../store/GlobalStore';

const useStyles = makeStyles((theme) => ({
    tabs: {
        backgroundColor: theme.palette.primary.main,
        marginRight: "2px",
        marginTop: "0%",
        width: "15%",
    },
    root: {
        border: "2px solid black",
        borderRadius: 8,
        height: "90%",
        marginTop: "7px"
    },
    titleText: {
        margin: "0px",
        color: "blue"
    },
    colorRed: {
        color: "red",
    },
    typographyText: {
        color: "#009900",
        fontSize: 14,
    }
}))

const TransactionAuditHistory: React.FC<{ debtors: IDebtor, transactions: ITransactionHistory[], mapped: boolean }> = (props) => {
    const { transactions, mapped } = props;
    const classes = useStyles();
    const { state, dispatch } = useGlobalState();

    // Inspired by the microsoft spinners.
    const useProgressStyles = makeStyles((theme) => ({
        root: {
            position: 'relative',
        },
        bottom: {
            color: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
        },
        top: {
            color: '#1a90ff',
            animationDuration: '550ms',
            position: 'absolute',
            left: 0,
        },
        circle: {
            strokeLinecap: 'round',
        },
    }));

    function Progress(props) {
        const classes = useProgressStyles();
        return (
            <div className={classes.root}>
                <CircularProgress
                    variant="determinate"
                    className={classes.bottom}
                    size={30}
                    thickness={4}
                    {...props}
                    value={100}
                />
                <CircularProgress
                    variant="indeterminate"
                    disableShrink
                    className={classes.top}
                    classes={{
                        circle: classes.circle,
                    }}
                    size={30}
                    thickness={4}
                    {...props}
                />
            </div>
        );
    }

    return (
        <React.Fragment >
            <h3 className={classes.titleText}> Transactions</h3>
            <Box p={1} width="100%" flexShrink={0} bgcolor="white" className={classes.root} >
                <Scrollbars autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={10}
                    autoHeight
                    autoHeightMin={140}
                    autoHeightMax={140}
                    style={{ width: "100%" }}>
                    {mapped ?
                        transactions.map((transactionsHistories) => {
                            if (transactionsHistories.activityType !== "0") {
                                return (
                                    <Typography gutterBottom className={classes.typographyText}>
                                        <p>
                                            {moment(transactionsHistories.activityDt).format(state.GlobalUtils?.settingValue)}
                                            &nbsp;{transactionsHistories.activity}
                                        </p>
                                    </Typography>
                                )
                            }
                            else {
                                return (
                                    < Typography variant="subtitle1" gutterBottom className={classes.colorRed}>
                                        <b>No Records to Display</b>
                                    </Typography>
                                )
                            }
                        })
                        : <Progress />
                    }
                </Scrollbars>
            </Box>
        </React.Fragment>
    )
}

export default TransactionAuditHistory


